//@flow
import * as React from 'react'
import { Field } from 'redux-form'
import RFCheckboxField from '../ReduxFormComps/RFCheckboxField';
import RFAutoCompleteField from '../ReduxFormComps/RFAutoCompleteField'
import { checkboxCustomStyle,checkboxCustomLabelStyle } from '../utils/checkbox';
import type { ContainerRowReduxAutoCompleteAndOverrideField$Props } from './flowTypes'
import renderTextField from '../MaterialUi/renderTextField'
import styles from '../utils/styles'

const checkboxOnChange=(e:any,props:ContainerRowReduxAutoCompleteAndOverrideField$Props)=>{
    const changeFieldValue = (props.changeFieldValue:any)
    if (e.target.checked){
    //    const selectFieldValue = props.parentProps[props.selectField] 
    //    const foundObject = props.datas.find((v)=>v[props.selectDataElement.code]==selectFieldValue)
    //    if (foundObject){
    //        changeFieldValue(props.textField,foundObject[props.selectDataElement.desc])
    //    }
    }else {
        changeFieldValue(props.autoCompleteField,'')
    }
}

const RenderAutoCompleteOrTextField=(props:ContainerRowReduxAutoCompleteAndOverrideField$Props)=>{
    if (!props.isOverride){
        return (
            <Field
                label={props.label}
                name={props.autoCompleteField}
                dataSource={props.datas}
                dataSourceConfig={props.autoCompleteDatasourceConfig}
                component={RFAutoCompleteField}
                fullWidth={true}
            />
        )
    }else {
        return (
            <Field
                name={props.autoCompleteField}
                component={renderTextField}
                label={props.label}
                style={styles.textFieldStyle}
            />
        )
    }
}

const ContainerRowReduxAutoCompleteAndOverrideField=(props:ContainerRowReduxAutoCompleteAndOverrideField$Props)=>{
    return (
        <div className='row'>
            <div className='col-sm'>
                <RenderAutoCompleteOrTextField {...props}/>
                
                <Field name={props.checkboxField} 
                    component={RFCheckboxField} 
                    label={props.checkboxLabel}
                    customStyle={checkboxCustomStyle}
                    customLabelStyle={checkboxCustomLabelStyle(props.isOverride)}
                    onChange={(e)=>checkboxOnChange(e,props)}
                />
            </div>        
        </div>
    )
}

export default ContainerRowReduxAutoCompleteAndOverrideField


// WEBPACK FOOTER //
// ./src/components/common/ContainerRowReduxAutoCompleteAndOverrideField.js